import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { IEnv } from '../interfaces';

export const ENV: InjectionToken<IEnv> = new InjectionToken('env');

export function provideSharedConfig(env: IEnv): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ENV, useValue: env }]);
}
